package com.vizio.redwolf.utils

import kotlin.js.JsExport

@JsExport
interface OffersEnvironment : Environment {
    val identityEnv: IdentityProxyEnvironment
}

@JsExport
abstract class BaseOffersEnvironment : OffersEnvironment

@JsExport
data class DevOffersEnvironment(
    override val identityEnv: IdentityProxyEnvironment
) : BaseOffersEnvironment()

@JsExport
data class StageOffersEnvironment(
    override val identityEnv: IdentityProxyEnvironment
) : BaseOffersEnvironment()

@JsExport
data class PreProdOffersEnvironment(
    override val identityEnv: IdentityProxyEnvironment
) : BaseOffersEnvironment()

@JsExport
data class ProdOffersEnvironment(
    override val identityEnv: IdentityProxyEnvironment
) : BaseOffersEnvironment()

fun chooseOffersEnvironment(envConfig: OffersEnvironmentConfig): BaseOffersEnvironment {
    return when (envConfig.environmentGroup) {
        EnvironmentGroup.PROD -> ProdOffersEnvironment(
            identityEnv = chooseIdentityProxyEnvironment(IdentityProxyEnvironmentConfig(envConfig.environmentGroup))
        )
        EnvironmentGroup.PREPROD -> PreProdOffersEnvironment(
            identityEnv = chooseIdentityProxyEnvironment(IdentityProxyEnvironmentConfig(envConfig.environmentGroup))
        )
        EnvironmentGroup.STAGE -> StageOffersEnvironment(
            identityEnv = chooseIdentityProxyEnvironment(IdentityProxyEnvironmentConfig(envConfig.environmentGroup))
        )
        EnvironmentGroup.DEV -> DevOffersEnvironment(
            identityEnv = chooseIdentityProxyEnvironment(IdentityProxyEnvironmentConfig(envConfig.environmentGroup))
        )
        EnvironmentGroup.TEST -> TODO("Test Offers Environment not defined yet!")
    }
}
